import InvoiceForm from "./InvoiceForm";

const CreateInvoice = () => {
    // const { guid } = useParams();
    // const [invoiceList, setInvoiceList] = useState([]);

    // const manageInvoiceList = async () => {
    //     try {
    //         const invoiceList = await API.get(`publisher/invoice/${guid}/list/1`);
    //         setInvoiceList(invoiceList?.data?.content);  
    //         console.log(invoiceList.data.content);
                      
    //     } catch (error) {}
    // }
    // useEffect(()=>{
    //     if(guid){
    //         manageInvoiceList();
    //     }
    // },[guid])
    return (
       <InvoiceForm mode = "add" /> 
    )
}

export default CreateInvoice;